import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { BannerSlide } from '@core/interfaces/banners';
import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'app-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss'],
})
export class BannerCarouselComponent implements OnChanges {
  @Input() banners: BannerSlide[] = [];
  @Input() loading = false;
  @ViewChild('carousel') carousel?: Carousel;

  slides: BannerSlide[] = [];
  currentIndex = 0;

  ngOnChanges(): void {
    this.slides = [...(this.banners ?? [])];
    this.currentIndex = 0;
  }

  onPageChange(event: { page: number }): void {
    this.currentIndex = event.page;
  }

  prev(): void {
    if (this.slides.length > 1) {
      this.carousel?.navBackward(new Event('click'));
    }
  }

  next(): void {
    if (this.slides.length > 1) {
      this.carousel?.navForward(new Event('click'));
    }
  }

  goTo(index: number): void {
    if (this.carousel && this.slides.length > 1) {
      this.carousel.page = index;
    }
  }

  onImageError(banner: BannerSlide): void {
    this.slides = this.slides.filter((slide) => slide !== banner);
    this.currentIndex = 0;
  }
}
